import TableLoadingWrapper from './TableLoadingWrapper';

export default TableLoadingWrapper;
